import authReducer from 'store/auth/auth.reducer';
import dictionariesReducer from "store/dictionaries/dictionaries.reducer";

const rooReducer = {
  auth: authReducer,
  dictionaries: dictionariesReducer,
};

export default rooReducer;
